import { render, staticRenderFns } from "./MarriageStatusTab.vue?vue&type=template&id=42403d56&scoped=true"
import script from "./MarriageStatusTab.vue?vue&type=script&lang=js"
export * from "./MarriageStatusTab.vue?vue&type=script&lang=js"
import style0 from "./MarriageStatusTab.vue?vue&type=style&index=0&id=42403d56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42403d56",
  null
  
)

export default component.exports